import {
  createWorkApi,
  deleteWorkApi,
  getWorksApi,
  updateWorkApi,
  getSingleWorkByIdApi,
} from "api/works";
import {
  takeEvery,
  fork,
  put,
  all,
  call,
  takeLatest,
} from "redux-saga/effects";
import {
  createWorkFailure,
  createWorkSuccess,
  deleteWorkFailure,
  deleteWorkSuccess,
  getWorksFailure,
  getWorksSuccess,
  getSingleWorkFailure,
  getSingleWorkSuccess,
  updateWorkFailure,
  updateWorkSuccess,
} from "./actions";
import {
  CREATE_WORK,
  DELETE_WORK,
  GET_WORKS,
  GET_SINGLE_WORK,
  UPDATE_WORK,
} from "./actionTypes";

function* getWorksSaga({ payload }) {
  try {
    const { data } = yield call(getWorksApi, payload);
    yield put(getWorksSuccess(data));
  } catch (error) {
    console.log(error);
    yield put(getWorksFailure(error));
  }
}

// ===================================================
// ===================================================

function* getSingleWorkSaga({ payload }) {
  try {
    const { data } = yield call(getSingleWorkByIdApi, payload);
    yield put(getSingleWorkSuccess(data));
  } catch (error) {
    console.log(error);
    yield put(getSingleWorkFailure(error));
  }
}

// ===================================================
// ===================================================

function* createWorkSaga({ payload }) {
  try {
    const { data, success } = yield call(createWorkApi, payload);
    yield put(createWorkSuccess(data));
    if (success) {
      yield payload?.toast?.success("تم اضافة العمل بنجاح");
      yield payload?.navigate("/works");
    }
  } catch (error) {
    console.log(error);
    yield put(createWorkFailure(error));
  }
}

// ===================================================
// ===================================================

function* updateWorkSaga({ payload }) {
  try {
    const { data, success } = yield call(updateWorkApi, payload);
    yield put(updateWorkSuccess(data));
    if (success) {
      yield payload?.toast?.success("تم تعديل العمل بنجاح");
      yield payload?.navigate("/works");
    }
  } catch (error) {
    console.log(error);
    yield put(updateWorkFailure(error));
  }
}

// ===================================================
// ===================================================

function* deleteWorkSaga({ payload }) {
  try {
    yield call(deleteWorkApi, payload);
    yield put(deleteWorkSuccess(payload));
  } catch (error) {
    console.log(error);
    yield put(deleteWorkFailure(error));
  }
}

// ===================================================
// ===================================================

export function* watchGetWorks() {
  yield takeEvery(GET_WORKS, getWorksSaga);
}

export function* watchGetSingleWork() {
  yield takeLatest(GET_SINGLE_WORK, getSingleWorkSaga);
}

export function* watchCreateWork() {
  yield takeLatest(CREATE_WORK, createWorkSaga);
}

export function* watchUpdateWork() {
  yield takeLatest(UPDATE_WORK, updateWorkSaga);
}
export function* watchDeleteWork() {
  yield takeLatest(DELETE_WORK, deleteWorkSaga);
}

// ===================================================
// ===================================================

function* worksSaga() {
  yield all([fork(watchGetWorks)]);
  yield all([fork(watchGetSingleWork)]);
  yield all([fork(watchDeleteWork)]);
  yield all([fork(watchUpdateWork)]);
  yield all([fork(watchCreateWork)]);
}

export default worksSaga;
